<!-- 学习班 添加 -->
<template>
  <div class="form_box">
    <div class="form_box__header">
      <AppPageHeader></AppPageHeader>
    </div>
    <el-card class="box-card">
      <div class="form_box__group__item">
        <div class="form_box__group__item__title">
          名称:
        </div>
        <div class="form_box__group__item__content">
          <el-input v-model="title" placeholder="请输入学习班名称" ref="input_title" style="width: 400px;"></el-input>
        </div>
      </div>
      <div class="form_box__group__item" v-if="showClassType">
        <div class="form_box__group__item__title">
          所属学习班分类:
        </div>
        <div class="form_box__group__item__content">
            <studyclassTidSelect @getsctId="getStudyClassTypeId" :showTitle="false"></studyclassTidSelect>
        </div>
      </div>
      <div class="form_box__group__item" v-if="showTypeSelect">
        <div class="form_box__group__item__title">
          类型:
        </div>
        <div class="form_box__group__item__content">          
              <el-radio-group v-model="type">
                <el-radio :label="0">党组织生活</el-radio>
                <el-radio :label="1">单位课程</el-radio>
              </el-radio-group>          
        </div>
      </div>
      <div class="form_box__group__item" v-if="type == 1">
        <div class="form_box__group__item__title">
          开 班 单 位:
        </div>
        <div class="form_box__group__item__content">
          <ClassUnitCascader @onValueChanged="onUnitValueChanged"></ClassUnitCascader>           
        </div>
      </div>
      <div class="form_box__group__item" v-if="type == 0">
        <div class="form_box__group__item__title">
          开班党组织:
        </div>
        <div class="form_box__group__item__content">
          <partyorgCascader @onValueChanged="onPartyOrgValueChanged"></partyorgCascader>           
        </div>
      </div>
    </el-card>
    <el-card class="box-card" style="margin-top: 20px;" v-loading="loading">
      <el-button style="margin-top: 12px;" type="primary" @click="publish">发布</el-button>
      <el-button style="margin-top: 12px;" type="info" @click="temporaty">暂存</el-button>
    </el-card>
  </div>
</template>

<script>
import { BaseVue } from "@/mixin/index";
import { studyclassAddApi } from "@/api/module/studyclass/studyclass";
import { studyclassTidSelect } from "@/views/module/studyclass/components/";
import { partyorgCascader } from "@/views/module/partyOrganization/components/";
import { ClassUnitCascader } from "@/views/module/classunit/components/";

export default {
  name: "StudyClassAdd",
  
  mixins: [BaseVue],
  
  components: {
    studyclassTidSelect,
    partyorgCascader,
    ClassUnitCascader
  },
  
  data() {
    return {
      title: "",
      tid: "", // 所属的学习班类型id
      type: 0, // 0:党组织生活 1:单位组织生活
      unitid: "", // 开班单位ID
      partyorgid: "", // 开班支部 id
      loading: false,
      status: ""
    };
  },
  
  computed: {
    showTypeSelect() {
      if (this.isAdmin) {
        return true;
      }
      if (this.isRoleinfo.hasPer10011) {
        return true;
      }
      return false;
    },
    
    typeIsPartyOrg() {
      return this.type == 0;
    },
    
    typeIsUnit() {
      return this.type == 1;
    },
    
    showClassType() {
      var show = false;

      if (this.roleid == "00003") {
        return true;
      }

      if (this.roleid == "00001" && this.type == 1) {
        return true;
      }

      if (this.isadmin && this.type == 1) {
        return true;
      }

      return show;
    }
  },
  
  methods: {
    // 发布
    publish() {
      this.loading = true;
      this.status = "0";
      this.addDemo();
    },
    
    // 暂存
    temporaty() {
      this.loading = true;
      this.status = "1";
      this.addDemo();
    },
    
    addDemo() {
      if (!this.title) {
        this.$message.error("学习班名称不能为空！");
        this.loading = false;
        return false;
      }

      if (this.typeIsPartyOrg) {
        // this.tid = 0;
      } else if (!this.tid) {
        this.$message.error("学习班类型不能为空！");
        this.loading = false;
        return false;
      }

      if (this.typeIsPartyOrg) {
        if (!this.partyorgid) {
          this.$message.error("开班支部不能为空！");
          this.loading = false;
          return false;
        }  
      }

      if (this.typeIsUnit) {
        if (!this.unitid) {
          this.$message.error("开班单位不能为空！");
          this.loading = false;
          return false;
        }      
      }

      let tid = this.tid;
      // 如果tid是对象，则取studyClassId属性
      if (this.tid && typeof this.tid === 'object' && this.tid.studyClassId) {
        tid = this.tid.studyClassId;
      }
      
      const data = {
        title: this.title,
        tid: tid,
        type: String(this.type),
        unitid: this.unitid,
        partyorgid: this.partyorgid,
        status: this.status
      };
      
      studyclassAddApi(data)
        .then(response => {
          this.$message({
            message: "操作成功！",
            type: "success"
          });
          setTimeout(() => {
            this.$router.replace({
              path: "/studyclass/dashboard"
            });
          }, 1500);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    
    getStudyClassTypeId(e) {
      this.tid = e;
    },
    
    getStudyClassTypeUnitid(e) {
      this.unitid = e;
    },
    
    onUnitValueChanged(data) {
      console.log(data);
      if (data) {
        this.unitid = data[data.length - 1];
      } else {
        this.unitid = "";
      }
      console.log("onUnitValueChanged", this.unitid);
    },
    
    onPartyOrgValueChanged(data) {
      console.log(data);
      if (data) {
        this.partyorgid = data[data.length - 1];
      } else {
        this.partyorgid = "";
      }
      console.log("onPartyOrgValueChanged", this.partyorgid);
    }
  },
  
  mounted() {
    console.log(this.roleid);
    
    if (!this.showTypeSelect) {
      if (this.isRoleinfo.hasPer10012) {
        this.type = 1;
      }
      
      if (this.isRoleinfo.hasPer10013) {
        this.type = 0;
      }
    }
  }
};
</script>

<style scoped lang="scss">

</style>

